/** Every "Try again" in the wizard looks the same: a small link next to what failed. */
export const RETRY_BUTTON = 'btn btn-link btn-xs'
